import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M4.7 8.01c0 1.81 1.48 3.29 3.3 3.29a3.295 3.295 0 0 0 0-6.59 3.31 3.31 0 0 0-3.3 3.3Zm1.5 0c0-.99.81-1.8 1.8-1.8.98 0 1.79.82 1.79 1.8a1.795 1.795 0 0 1-3.59 0Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M.35 8.37c2 3.53 4.72 5.47 7.65 5.47 2.93 0 5.65-1.94 7.65-5.47a.75.75 0 0 0 0-.74c-2-3.53-4.72-5.47-7.65-5.47-2.93 0-5.65 1.94-7.65 5.47a.75.75 0 0 0 0 .74ZM8 12.34c-2.27 0-4.44-1.54-6.13-4.34C3.56 5.2 5.73 3.66 8 3.66S12.44 5.2 14.13 8c-1.69 2.8-3.86 4.34-6.13 4.34Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  l,
  n
];
function r(i, s) {
  return t(), o("svg", c, [...d]);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
